import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes, FundService } from '@gs-2.0/core';

export const transferAccessGuard: CanActivateFn = () => {
  const fundService = inject(FundService);
  const router = inject(Router);

  if (fundService.isTransferEligible()) {
    return true;
  }

  router.navigate([AppRoutes.FUND_DASHBOARD]);
  return false;
};
